import React, { Component } from "react";
import { Link } from "react-router-dom";

import Navigation from "./Navigation";
import PeriodicTable from "./PeriodicTable";
import DelayLink from "./DelayLink";

import health from "./img/icon-healthcare.svg";
import retail from "./img/icon-retail.svg";
import education from "./img/icon-highered.svg";
import whiteE from "./img/white-e.svg";

import imgOne from "./img/Retail/enhanced-instore-experience-icon_2-color.svg";
import imgTwo from "./img/Retail/operational-excellence-icon_2-color.svg";
import imgThree from "./img/Retail/brand-protection-icon_2-color.svg";

import "./css/SelectVertical.scss";
import "./css/animate.css";
import "./css/CaseStudy.scss";

class CaseStudy extends Component {
  constructor(props) {
    super(props);

    this.state = {
      headerAnimate: "fadeInUp",
      verticalAnimate: "animated bounceInUp",
      verticalSelected: false
    };
    console.log(this.props.location.state);
  }

  verticalClick(e) {
    this.setState({
      headerAnimate: "fadeOutUp",
      verticalAnimate: "animated bounceOutUp",
      verticalSelected: true,
      verticalName: e.target.dataset.vertical
    });

    console.log(e.target.dataset.vertical);
  }
  goBack() {
    this.props.history.goBack();
  }
  render() {
    return (
      <div className="caseStudy">
        <div className="left">
          {this.props.location.state.elements.map((item, i) => (
            <Link
              to={{
                pathname: "/element",
                state: {
                  selectedabbv: item.abbreviation,
                  selectedLabel: item.label,
                  selectedColor: item.color,
                  selectedContent: item.content,
                  selectedTitle: item.title,
                  selectedBack: item.selectedBack,
                  selectedUrl: item.url
                }
              }}
            >
              <div
                className={"element " + item.color + " animated flipInX one"}
              >
                {item.color === "darkGray" ? (
                  <span className="partnerP">P</span>
                ) : (
                  <img src={whiteE} className="cornerLogo" />
                )}
                <h2>{item.abbreviation}</h2>
                <h3>{item.label}</h3>
              </div>
            </Link>
          ))}

          <div className="buttons">
            <button className="backButton" onClick={this.goBack.bind(this)}>
              <i className="fa fa-chevron-left" aria-hidden="true" /> Back
            </button>

            <Link to="/table">
              <button className="learnMore table" target="_blank" rel nofollow>
                View Table
              </button>
            </Link>
          </div>
        </div>

        <div className="right">
          <i
            className="fa fa-times closeElement"
            aria-hidden="true"
            onClick={this.goBack.bind(this)}
          />
          <h2>{this.props.location.state.contentTitle}</h2>
          <img src={this.props.location.state.image} />
          <h4>{this.props.location.state.subTitle}</h4>
          <div
            dangerouslySetInnerHTML={{
              __html: this.props.location.state.content
            }}
          />
        </div>
      </div>
    );
  }
}

export default CaseStudy;
